import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RecalculateMemberPointPage } from './recalculate-member-point.page';

const routes: Routes = [
  {
    path: '',
    component: RecalculateMemberPointPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RecalculateMemberPointPageRoutingModule {}
